module.exports = __webpack_public_path__ + "img/ic_24_social_email.325c8c5c.svg";